import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-d2de1d26")
const _hoisted_1 = {
  key: 0,
  class: "fs-14 lh-21 color-font fw-normal mt-5 representative-example"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Przykład reprezentatywny", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "icon-wrapper" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.representativeExample?.pl)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: _normalizeClass({'fold': !_ctx.active})
        }, _toDisplayString(_ctx.representativeExample?.pl), 3),
        _createElementVNode("div", {
          class: "trigger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.active = !_ctx.active))
        }, [
          (_ctx.active)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Zwiń"))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "Rozwiń")),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["icon", {'is-active': _ctx.active}])
            }, null, 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}